import { Link } from "react-router-dom";
import React from "react";
import NutradSPIcon from "../../assets/img/nt logo smart pipe.png";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-8 mt-auto">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 items-start">
          {/* Support Section */}
          <div className="col-span-1 space-y-4">
            <h2 className="text-lg font-semibold text-gray-900">Support</h2>
            <div className="space-y-3 text-gray-600">
              <p className="flex items-center">
                <span>Need help? Contact us at</span>
              </p>
              <a
                href="mailto:support@nutrad.io"
                className="text-blue-600 hover:text-blue-700 transition-colors duration-200 flex items-center gap-2"
              >
                support@nutrad.io
              </a>
            </div>
          </div>

          {/* Logo Section */}
          <div className="col-span-1 flex flex-col items-center justify-center space-y-4">
            <img
              className="h-12 w-auto object-contain"
              src={NutradSPIcon}
              alt="nutrād logo"
            />
            <div className="text-center">
              <p className="text-sm text-gray-500">
                Empowering Product Data Management
              </p>
            </div>
          </div>

          {/* Links Section */}
          <div className="col-span-1 space-y-4 flex flex-col items-end">
            <h2 className="text-lg font-semibold text-gray-900">Quick Links</h2>
            <div className="grid grid-cols-1 gap-2 text-right">
              <Link to="/products" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                Products
              </Link>
              <Link to="/import" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                Import
              </Link>
              <Link to="/validations" className="text-gray-600 hover:text-blue-600 transition-colors duration-200">
                Validations
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="text-center text-gray-600 text-sm">
            <p>© {new Date().getFullYear()} nutrād. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
